import React, { useState } from 'react';

import { AlignCenter as FormatAlignCenterOutlined, AlignLeft as FormatAlignLeftOutlined, AlignRight as FormatAlignRightOutlined } from "lucide-react";
import { ToggleButton } from '@mui/material';

import RadioGroupInput from './RadioGroupInput';

type Props = {
  label: string;
  defaultValue: string | null;
  onChange: (value: string | null) => void;
};
export default function TextAlignInput({ label, defaultValue, onChange }: Props) {
  const [value, setValue] = useState(defaultValue ?? 'left');

  return (
    <RadioGroupInput
      label={label}
      defaultValue={value}
      onChange={(value) => {
        setValue(value);
        onChange(value);
      }}
    >
      <ToggleButton value="left">
        <FormatAlignLeftOutlined className="size-4" />
      </ToggleButton>
      <ToggleButton value="center">
        <FormatAlignCenterOutlined className="size-4" />
      </ToggleButton>
      <ToggleButton value="right">
        <FormatAlignRightOutlined className="size-4" />
      </ToggleButton>
    </RadioGroupInput>
  );
}
